// src/features/properties/Property.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/free-solid-svg-icons'
import { useState } from 'react'
import PropertyModal from '../properties/PropertyModal'
import CloudinaryImage from '../utils/CloudinaryImage'
import getPublicId from '../utils/getPublicId'

const Property = ({ property }) => {
    const [showModal, setShowModal] = useState(false)

    const firstImagePublicId = property.images?.[0] ? getPublicId(property.images[0]) : null
    const fallbackUrl = property.images?.[0]?.url || null

    const handleCopyDescription = async (e) => {
        e.stopPropagation()
        try {
            const text = property.description || "Không có mô tả"
            await navigator.clipboard.writeText(text)
        } catch (err) {
            console.error(err)
        }
    }

    return (
        <>
            <div onClick={() => setShowModal(true)} style={{ cursor: 'pointer' }}>
                <div className="border rounded p-3 bg-white shadow-sm h-100 d-flex flex-column">
                    {/* === KHUNG ẢNH CỐ ĐỊNH – QUAN TRỌNG NHẤT === */}
                    <div className="ratio ratio-4x3 mb-2">  {/* Tỷ lệ 4:3 – chuẩn thumbnail BĐS */}
                        {firstImagePublicId ? (
                            <CloudinaryImage
                                publicId={firstImagePublicId}
                                width={400}
                                height={300}
                                crop="limit"
                                alt="BĐS"
                                className="rounded w-100 h-100"
                                style={{ objectFit: 'cover' }}
                                fallbackUrl={fallbackUrl}
                            />
                        ) : (
                            <div className="bg-light rounded d-flex align-items-center justify-content-center w-100 h-100">
                                <FontAwesomeIcon icon={faImage} size="3x" className="text-muted" />
                            </div>
                        )}
                    </div>

                    {/* === NỘI DUNG CARD === */}
                    <div className="mt-auto">  {/* Đẩy nội dung xuống dưới nếu cần */}
                        {property.description && (
                            <div className="mb-2">
                                <p className=" text-mutedlh-sm">
                                    {property.description}
                                </p>
                                <button
                                    type="button"
                                    onClick={handleCopyDescription}
                                    className="btn btn-sm btn-outline-info"
                                >
                                    <i className="bi bi-clipboard-check me-1"></i>
                                    Copy mô tả
                                </button>
                            </div>
                        )}

                        {/* Trạng thái */}
                        <div className="mb-2">
                            {property.status === "Đang cho thuê" && (
                                <span className="badge bg-primary text-white px-3 py-2">
                                    <i className="bi bi-house-door me-2"></i>
                                    Đang cho thuê
                                </span>
                            )}
                            {property.status === "Đã cho thuê" && (
                                <span className="badge bg-success text-white px-3 py-2">
                                    <i className="bi bi-check-circle me-2"></i>
                                    Đã cho thuê
                                </span>
                            )}
                            {property.status === "Đã bán" && (
                                <span className="badge bg-warning text-white px-3 py-2">
                                    <i className="bi bi-cart-check me-2"></i>
                                    Đã bán
                                </span>
                            )}
                        </div>

                        {/* Tạm xóa */}
                        {property.isTempDeleted && (
                            <div className="mb-2">
                                <span className="badge bg-danger text-white px-3 py-2">
                                    <i className="bi bi-trash3 me-2"></i>
                                    Đang tạm xóa
                                </span>
                            </div>
                        )}

                        {/* Ngày cập nhật */}
                        <small className="text-info fst-italic">
                            <i className="bi bi-pencil-square me-1"></i>
                            {new Date(property.updatedAt).toLocaleDateString('vi-VN', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                            })}
                        </small>
                    </div>
                </div>
            </div>

            <PropertyModal
                property={property}
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </>
    )
}

export default Property